import * as types from '@/store/mutationTypes';

export const toggleClientMaintenanceMode = async ({ commit }, sid) => {
  commit(types.COMMON_TOGGLE_CLIENT_MAINTENANCE_MODE, sid, { root: true });
};
